import { FC } from 'react';
import { Modal, ModalProps } from '../../../components/Modal';
import { FormattedMessage } from 'react-intl';
import { useLatestMalfunctions } from '../../../services/malfunctions';
import { Spinner } from '../../../components/Spinner';
import { PlaceCenter } from '../../../components/PlaceCenter';
import { MalfunctionItem } from '../MalfunctionQuestion/views';

interface MalfunctionsListProps extends ModalProps {}

export const MalfunctionsList: FC<MalfunctionsListProps> = (props) => {
  const { running, result } = useLatestMalfunctions(100);

  return (
    <Modal title={<FormattedMessage id="Malfunction.Inspection.List" />} {...props}>
      {running && (
        <PlaceCenter>
          <Spinner />
        </PlaceCenter>
      )}
      {result?.items?.map((item) => (
        <MalfunctionItem key={item.id}>{item.name}</MalfunctionItem>
      ))}
    </Modal>
  );
};
